import React, { useState, useRef, useEffect, createElement } from 'react';
import moment from 'moment';
const DataVNowDateTime = (props) => {
    const { format = `YYYY-MM-DD HH:mm:ss`, interval = 1000, prefix, suffix, week, ...rest } = props;
    const timerRef = useRef(null);
    const [dateTime, setDateTime] = useState(``);
    const [weeks, setWeeks] = useState(``);
    const handleClearInterval = React.useCallback(() => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    }, []);
    const handleSetInterval = () => {
        if (timerRef.current) {
            handleClearInterval();
        }
        timerRef.current = window.setInterval(() => {
            setDateTime(moment().format(format));
            if (week) {
                setWeeks(moment().format('dddd'));
            }
        }, interval);
    };
    useEffect(() => {
        handleSetInterval();
        return () => {
            handleClearInterval();
        };
    }, []);
    return (createElement("div", { ...rest },
        prefix || null,
        createElement("span", null, dateTime),
        suffix || null,
        week ? createElement("span", { style: { marginLeft: 8 } }, weeks) : null));
};
export default DataVNowDateTime;
